<template>
  <div class="main">
    <component :is="sidebarComponent" />
    <div class="content-wrapper">
      <the-header />
      <div class="content">
        <component :is="pageComponent" />
      </div>
    </div>
  </div>
</template>

<script>
  import { watch, ref, shallowRef, onBeforeMount } from 'vue';
  import { useStore } from 'vuex';
  import { useRoute } from 'vue-router';

  import * as Pages from '@/components/pages';
  import TheHeader from '@/components/TheHeader';
  import * as Sidebars from '@/components/sidebar';

  export default {
    name: 'AuthPagesController',
    components: { ...Pages, ...Sidebars, TheHeader },
    methods: {
      changeName(data) {
        console.log(data);
      },
    },
    setup() {
      const ROLES_TO_PAGES_NAMES = {
        adminuk: 'AdminUk',
        admin: 'Admin',
        manager: 'Manager',
        client: 'Client'
      };

      const store = useStore();
      const route = useRoute();
      const pageComponent = shallowRef(null);
      const sidebarComponent = shallowRef(null);
      const role = store.getters['app/userRole'];
      const isDependOnRole = ref(route.meta.dependOnRole);

      const getPageComponent = (pageName) => {
        const prefix = ROLES_TO_PAGES_NAMES[role.toLowerCase()];

        if (isDependOnRole.value) {
          pageComponent.value = `${prefix}${pageName}Page`;
        } else {
          pageComponent.value = pageName;
        }
      };

      const getSidebarComponent = () => {
        const prefix = ROLES_TO_PAGES_NAMES[role.toLowerCase()];
        sidebarComponent.value = `${prefix}Sidebar`;
      };

      watch(
        () => route.name,
        (pageName) => {
          isDependOnRole.value = route.meta.dependOnRole;
          getPageComponent(pageName);
          getSidebarComponent();
        }
      );

      onBeforeMount(async () => {
        isDependOnRole.value = route.meta.dependOnRole;
        getPageComponent(route.name);
        getSidebarComponent();
      });

      getPageComponent(route.name);
      getSidebarComponent();

      return { pageComponent, sidebarComponent };
    },
  };
</script>

<style lang="scss" scoped>
  .main {
    display: flex;
    flex: 1;
    overflow: hidden;
    max-height: 100vh;

    .content {
      &-wrapper {
        display: flex;
        flex: 1;
        overflow: hidden;
        flex-direction: column;
      }

      overflow: auto;
      padding: 32px 36px 16px 36px;
      flex: 1;
      min-height: 0;
      max-height: 100%;
    }
  }
</style>
